// for css attribute:
import "styled-components/macro";

import HStack from "shared/components/layout/stack/HStack";
import Loading from "shared/components/feedback/loading/Loading";
import PrimaryButton from "shared/components/inputs/button/PrimaryButton";
import PropTypes from "prop-types";
import SecondaryButton from "shared/components/inputs/button/SecondaryButton";
import { StyledAction } from "shared/components/feedback/modals/MasterModal.styles";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import styled from "styled-components";

export const LoadingWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-content: center;
    background-color: white;
`;

const ModalActions = ({
    primaryAction,
    secondaryAction,
    tertiaryAction,
    isSubmiting,
    ...rest
}) => {
    return (
        <StyledAction {...rest}>
            {
                isSubmiting ?
                <LoadingWrapper>
                    <Loading></Loading>
                </LoadingWrapper>
                : 
                <HStack spacing="Zero_5">
                    {tertiaryAction && !isSubmiting && <TertiaryButton {...tertiaryAction} />}
                    {secondaryAction && !isSubmiting && <SecondaryButton {...secondaryAction} />}
                    {primaryAction && !isSubmiting && (
                        <PrimaryButton css="flex: 1" {...primaryAction} />
                    )}
                </HStack>
            }
        </StyledAction>
    );
};

ModalActions.propTypes = {
    primaryAction: PropTypes.object,
    secondaryAction: PropTypes.object,
    tertiaryAction: PropTypes.object,
    isSubmiting: PropTypes.bool,
};

export default ModalActions;
